var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 689.669 318.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-935 -2492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1065.077 2493.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.721 76.489v44.731m34.963-57.038v56.823m34.962-59.519v59.734m34.963-51.747v51.532m34.962-40.953v41.168m34.963-40.736v40.522m34.963-57.658v57.872m34.962-67.645v67.645m34.963-66.246v66.246m34.962-65.744v65.744",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M417.905 135.306h32.563v13.495h-32.563z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 462.864,
    height: 260.361,
    rx: 10,
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M462.864 12.62v216.77H0V12.62z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.892,
    cy: 5.892,
    r: 5.892,
    transform: "translate(225.539 237.805)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M180.522 260.361h101.821v46.69H180.522zm-20.277 46.69h142.374a8.774 8.774 0 018.774 8.774v.5h0-159.922 0v-.5a8.774 8.774 0 018.774-8.774zM76.962 12.62v216.77M91.637 25.121h358.832v96.099H91.637z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.637 84.521c44.034-21.688 74.4-33.328 116.915-20.675s65.288 26.512 99.2 5.411 64.276-21.543 93.124-15.248 49.6-12.266 49.6-12.266",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.311 48.757)",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(0 22.914)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(34.963 10.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(69.925 7.911)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(104.888 15.898)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(139.851 26.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(174.813 26.908)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(209.776 9.773)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(244.738)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(279.701 1.399)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.409,
    cy: 2.409,
    r: 2.409,
    transform: "translate(314.664 1.901)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M282.342 121.221v108.17m13.258-87.337h10.969m-5.485 5.485V136.57m-35.188 2.716l-3.815 6.607h7.629zm0 22.023l-3.815 6.607h7.629zm0 45.118l-3.815 6.607h7.629zm0-15.952l3.814-6.607h-7.629zM0 63.132h76.962M0 79.758h76.962M0 96.384h76.962M0 113.01h76.962M0 129.636h76.962M0 146.261h76.962M0 162.887h76.962M0 179.513h76.962M0 196.139h76.962M0 212.765h76.962"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.973,
    cy: 10.973,
    r: 10.973,
    transform: "translate(9.894 26.536)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M41.75 31.787h26.727M41.75 38.113h26.727M41.75 44.44h26.727m255.02 97.614h86.645"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 4.94,
    r: 4.94,
    transform: "translate(361.879 137.114)",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.54 142.085l2.583 2.584 4.643-4.873m4.421-4.49v13.495m5.23-4.079l5.337-5.337m0 5.337l-5.337-5.337m-21.512 18.48h32.563v13.495h-32.563zM295.6 164.613h10.969m-5.485 5.484v-10.969m22.413 5.485h86.645",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 4.94,
    r: 4.94,
    transform: "translate(338.868 159.673)",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.54 164.643l2.583 2.584 4.643-4.873m4.421-4.489v13.495m5.23-4.079l5.337-5.337m0 5.337l-5.337-5.337m-21.512 18.48h32.563v13.495h-32.563zM295.6 187.171h10.969m-5.485 5.485v-10.969m22.413 5.484h86.645",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 4.94,
    r: 4.94,
    transform: "translate(381.133 182.231)",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.54 187.202l2.583 2.584 4.643-4.873m4.421-4.489v13.495m5.23-4.079l5.337-5.337m0 5.337l-5.337-5.337m-21.512 18.479h32.563v13.495h-32.563zM295.6 209.73h10.969m-5.485 5.485v-10.969m22.413 5.484h86.645",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.94,
    cy: 4.94,
    r: 4.94,
    transform: "translate(348.748 204.79)",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.54 209.761l2.583 2.584 4.643-4.872m4.421-4.491v13.495m5.23-4.079l5.337-5.337m0 5.337l-5.337-5.337",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.786 47.19h-26.43v18.416h10.375l2.84 4.92 2.841-4.92h10.374z",
    fill: "#fff",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(251.391 58.179)",
    fill: "#6e7e9d",
    fontSize: 9,
    fontFamily: "TitilliumWeb-SemiBold, Titillium Web",
    fontWeight: 600,
    letterSpacing: ".025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("circle", {
    cx: 7.585,
    cy: 7.585,
    r: 7.585,
    transform: "translate(91.637 134.096)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(117.208 137.114)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(185.666 137.114)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.585,
    cy: 7.585,
    r: 7.585,
    transform: "translate(91.637 156.655)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(117.208 159.673)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(185.666 159.673)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.585,
    cy: 7.585,
    r: 7.585,
    transform: "translate(91.637 179.213)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(117.208 182.231)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(185.666 182.231)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.585,
    cy: 7.585,
    r: 7.585,
    transform: "translate(91.637 201.772)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(117.208 204.79)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.066,
    height: 9.88,
    rx: 4.674,
    transform: "translate(185.666 204.79)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 103.556,
    height: 175.369,
    rx: 6.674,
    transform: "translate(936 2493)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M936 2644.078h103.556M936 2611.539h103.556"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.656,
    cy: 5.656,
    r: 5.656,
    transform: "translate(982.121 2650.294)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(942.468 2502.32)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(966.865 2502.32)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(991.263 2502.32)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(1015.661 2502.32)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(942.468 2530.331)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(966.865 2530.331)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(991.263 2530.331)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(1015.661 2530.331)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(942.468 2558.342)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(966.865 2558.342)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(991.263 2558.342)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(1015.661 2558.342)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(942.468 2586.353)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(966.865 2586.353)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(991.263 2586.353)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(1015.661 2586.353)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(942.468 2617.535)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(966.865 2617.535)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(991.263 2617.535)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.056,
    height: 19.556,
    rx: 4.037,
    transform: "translate(1015.661 2617.535)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.472,
    cy: 4.472,
    r: 4.472,
    transform: "translate(1020.217 2622.841)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1008.052 2700.364h33.274v19.556h-33.274z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1024.291 2711.813)",
    fill: "#0c9",
    stroke: "#707070",
    strokeWidth: 2,
    fontSize: 9,
    fontFamily: "TitilliumWeb-SemiBold, Titillium Web",
    fontWeight: 600,
    letterSpacing: ".025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.79,
    y: 0
  }, "API")), /*#__PURE__*/React.createElement("circle", {
    cx: 24.28,
    cy: 24.28,
    r: 24.28,
    transform: "translate(1575.11 2506.972)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.39 2550.247a18.995 18.995 0 1119-19 19.016 19.016 0 01-19 19z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.28,
    cy: 24.28,
    r: 24.28,
    transform: "translate(1575.11 2571.465)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.39 2614.74a19 19 0 1119-19 19.016 19.016 0 01-19 19z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.28,
    cy: 24.28,
    r: 24.28,
    transform: "translate(1575.11 2636.958)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.28,
    cy: 24.28,
    r: 24.28,
    transform: "translate(1575.11 2703.958)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.39 2680.233a18.995 18.995 0 1119-18.994 19.015 19.015 0 01-19 18.994zm0 67a18.995 18.995 0 1119-18.994 19.015 19.015 0 01-19 18.994z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 4,
    d: "M1575.111 2531.251h-47.17m47.17 65.622h-47.17m47.17 66.621h-47.17m47.17 67h-47.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.387 2583.309l-7.632 12.664 7.632 4.512v-17.176z",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.02 2595.975l-7.635-12.666v17.176zm-7.633 12.203v-6.246l-7.632-4.509z",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.384 2601.932v6.246l7.636-10.756zm0-1.446l7.632-4.512-7.632-3.469z",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.755 2595.975l7.632 4.512v-7.983zm16.461 57.575l-2.962 1.509-14.3 7.286a8.52 8.52 0 0112.6-8.541l1.7-.865.252-.129a10.409 10.409 0 00-16.521 8.424q0 .4.03.793a1.891 1.891 0 01-1.028 1.829l-.894.456v2.126l2.632-1.341.852-.436.84-.428 15.08-7.682 1.694-.864 3.5-1.785v-2.125zm3.471 2.486l-19.42 9.888-1.694.864-3.487 1.777v2.124l3.463-1.764 2.961-1.509 14.319-7.3a8.7 8.7 0 01.073 1.12 8.521 8.521 0 01-12.688 7.428l-.1.055-1.838.937a10.408 10.408 0 0016.523-8.419c0-.267-.01-.534-.031-.8a1.9 1.9 0 011.027-1.83l.9-.457z",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.925 2528.901c.372-2.489-1.523-3.827-4.115-4.72l.841-3.372-2.052-.51-.819 3.283c-.539-.135-1.092-.261-1.644-.387l.826-3.3-2.051-.511-.841 3.37c-.446-.1-.886-.2-1.311-.309v-.01l-2.83-.707-.545 2.192s1.522.349 1.491.37a1.093 1.093 0 01.956 1.194l-.958 3.84a2.039 2.039 0 01.213.068l-.217-.053-1.341 5.38a.748.748 0 01-.941.486c.021.029-1.492-.371-1.492-.371l-1.019 2.347 2.672.667c.5.124.983.255 1.46.377l-.847 3.41 2.05.51.84-3.371c.56.15 1.1.291 1.635.424l-.838 3.358 2.053.51.849-3.4c3.5.663 6.129.4 7.239-2.769.892-2.548-.044-4.019-1.886-4.977a3.271 3.271 0 002.622-3.019zm-4.689 6.575c-.633 2.548-4.925 1.17-6.317.824l1.128-4.517c1.392.348 5.853 1.036 5.189 3.693zm.635-6.612c-.578 2.319-4.149 1.139-5.307.851l1.02-4.1c1.159.294 4.889.831 4.287 3.249z",
    fill: "#6e7e9d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 4,
    d: "M1024.689 2637.092v63.272m69.521 78.032h70.089v-68.39m-139.61 10.496v57.891h64.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1088.9 2784.746v-12.7m5.31 12.7v-12.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1597 2726)",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1590 2726)",
    fill: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1604 2726)",
    fill: "#6e7e9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.5dd952b1521ed544a3dd9dc174cb9b77.svg";
export { ForwardRef as ReactComponent };